import { STYLIST_API_URL } from '@admin-panel/config/env';
import { overrideFetchBaseQuery } from '../../utils/overrideFetchBaseQuery';
import { baseQueryWithZodValidation } from '../../utils/baseQueryWithZodValidation';

export const stylistTagTypes = [
  'PromptTemplate',
  'StylingWorkflow',
  'Look',
  'Occasion',
  'LookGroup',
] as const;

export const stylistBaseQuery = baseQueryWithZodValidation(
  overrideFetchBaseQuery({
    // baseUrl: 'http://localhost:8000/console/',
    baseUrl: STYLIST_API_URL || '/console/',
  }),
  {},
);
